var menu = {
    width: 0,
    left: 0,
    active: document.querySelectorAll(".main__menu-item-link.active")[0],
    init: function(menu){
        if(993 > (window.innerWidth || document.documentElement.clientWidth)){
            this.options = menu, this.mobileCreateListeners();
        }else if(typeof(this.active) == 'object'){
            this.options = menu, this.borderPosition, this.borderPositionBack, this.createListeners();
            menu.border.style.width = this.active.parentElement.offsetWidth + "px";
            menu.border.style.left = this.active.parentElement.offsetLeft + "px";
        }

    },
    mobileCreateListeners: function (){
        this.options.hamburger.addEventListener("click", function() {
            this.children[0].classList.toggle("is-active");
            this.nextElementSibling.classList.toggle("open");
        });
        this.options.menu.addEventListener("click", function(e) {
            if(e.target.nodeName == "LI" && e.target.classList.contains("main__menu-item") && e.target.classList.contains("dropdown")) {
                e.preventDefault();
                e.target.classList.toggle("active");
                e.target.children[0].classList.toggle("active");
                e.target.children[0].nextElementSibling.classList.toggle("active");
            }else if(e.target.nodeName == "A" && e.target.classList.contains("main__menu-item-link")){
                e.preventDefault();
                Object.values(document.getElementsByClassName("main__menu-item-link")).forEach(function(item){
                    item.classList.remove("active");
                });
                Object.values(document.getElementsByClassName("dropdown__items")).forEach(function(item){
                    item.classList.remove("active");
                });
            }
        });
    },
    createListeners: function (){
        var menu = this;
        this.options.menu.addEventListener("mouseover", function (e) {
            menu.borderPosition(e.target);
        });
        this.options.menu.addEventListener("mouseleave", function (e) {
            menu.borderPositionBack(e.target);
        });
        this.options.menu.addEventListener("click", function (e) {
            Object.values(document.getElementsByClassName("main__menu-item-link")).forEach(function (item) {
                item.classList.remove("active");
            });
            Object.values(document.getElementsByClassName("dropdown__items")).forEach(function (item) {
                item.classList.remove("active");
            });
            if (e.target.parentElement.classList.contains("dropdown__item")) {
                e.target.closest(".main__menu-item").children[0].classList.add("active");
                menu.active = e.target.closest(".main__menu-item").children[0];
            } else {
                e.target.classList.add("active");
                menu.active = e.target;
            }
        });
    },
    borderPosition: function(el){
        var border = this.options.border;
        if(el.nodeName == "A" && el.classList.contains("main__menu-item-link")) {
            border.style.width = el.parentElement.offsetWidth + "px";
            border.style.left = el.parentElement.offsetLeft + "px";
        }
    },
    borderPositionBack: function(el){
        var border = this.options.border;
        if(el.nodeName == "UL" && typeof(this.active) == 'object') {
            border.style.width = this.active.parentElement.offsetWidth + "px";
            border.style.left = this.active.parentElement.offsetLeft + "px";
        }
    }
}

menu.init({
    hamburger: document.getElementById("mob-hamburger"),
    menu: document.getElementById("main__menu-items"),
    border: document.getElementById("slide-border"),
});